import React from "react";
import { useState } from "react";
import { Switch } from "@headlessui/react";

interface ToggleProps {
  label: string;
  value?: string;
  current: boolean;
  onChange?: (state?: boolean) => void;
}

export default function Toggle({ label, onChange, current }: ToggleProps) {
  const [enabled, setEnabled] = useState(current);

  const handleChange = () => {
    setEnabled(!enabled);
    onChange && onChange(!enabled);
  };

  return (
    <Switch.Group>
      <div className="flex items-center">
        {label && <Switch.Label className="mr-4">{label}</Switch.Label>}
        <Switch
          as="div"
          checked={enabled}
          onChange={handleChange}
          className={`${
            enabled ? "bg-indigo-600" : "bg-gray-200"
          } relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none`}
        >
          <span
            className={`${
              enabled ? "translate-x-6" : "translate-x-1"
            } inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}
          />
        </Switch>
      </div>
    </Switch.Group>
  );
}
